import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

const toneClasses = {
    neutral: 'bg-accent text-accent-foreground',
    info: 'bg-info-subtle text-info-subtle-foreground',
    warning: 'bg-warning-subtle text-warning-subtle-foreground',
    danger: 'bg-danger-subtle text-danger-subtle-foreground',
} as const;

interface ErrorPageLayoutProps {
    icon: ReactNode;
    tone?: keyof typeof toneClasses;
    code: string;
    title: string;
    description: string;
    actions?: ReactNode;
}

export function ErrorPageLayout({ icon, tone = 'neutral', code, title, description, actions }: ErrorPageLayoutProps) {
    return (
        <div className="bg-background flex min-h-screen flex-col items-center justify-center px-6 text-center">
            <div className={cn('flex size-16 items-center justify-center rounded-xl [&>svg]:size-8', toneClasses[tone])}>{icon}</div>
            <p className="text-muted-foreground mt-6 text-sm font-semibold tracking-wide uppercase">{code}</p>
            <h1 className="mt-2 text-2xl font-semibold">{title}</h1>
            <p className="text-muted-foreground mt-2 max-w-md text-sm">{description}</p>
            {actions ? <div className="mt-8 flex items-center justify-center gap-3">{actions}</div> : null}
        </div>
    );
}
